import React from 'react';
import { useEmailConnectionsService, EMAIL_CONNECTIONS_UPDATED } from 'nekst-api';
import { InformationMessage } from 'features/nekst-widgets';
import { useDataLoaderNew } from 'data-loader';

export default function GmailPriorityWarning() {
  const emailConnectionsService = useEmailConnectionsService();

  const {
    data: connection,
    loading,
  } = useDataLoaderNew(
    () => emailConnectionsService.getConnection(),
    {
      dependencies: [],
      events: [EMAIL_CONNECTIONS_UPDATED]
    }
  );

  const hasGmailConnection = connection !== null && !loading;

  if (!hasGmailConnection) {
    return null;
  }

  return (
    <InformationMessage>
      Gmail connection is currently active and has priority. Custom domain emails will only be used if Gmail is disconnected.
    </InformationMessage>
  );
}
